import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetProductionTriggersQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionTriggerDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionTriggerDocumentSortInput> | Types.ProductionTriggerDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionTriggersQuery = { __typename?: 'Query', productionTriggers?: { __typename?: 'ProductionTriggersConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionTriggerDocument', id: string, tenantId: string, productionTriggerId: string, name: string, source: Types.ProductionTriggerSource, unit: Types.ProductionTriggerUnit, offset: number, expireBy?: Types.TDateISO | null, status: Types.ProductionTriggerStatus, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type ProductionTriggerSummaryFragment = { __typename?: 'ProductionTriggerDocument', id: string, tenantId: string, productionTriggerId: string, name: string, source: Types.ProductionTriggerSource, unit: Types.ProductionTriggerUnit, offset: number, expireBy?: Types.TDateISO | null, status: Types.ProductionTriggerStatus, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO };

export type ProductionTriggerDetailsFragment = { __typename?: 'ProductionTriggerStateData', tenantId: string, productionTriggerId: string, name: string, source: Types.ProductionTriggerSource, unit: Types.ProductionTriggerUnit, offset: number, expireBy?: Types.TDateISO | null, status: Types.ProductionTriggerStatus, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO };

export const ProductionTriggerSummaryFragmentDoc = new TypedDocumentString(`
    fragment ProductionTriggerSummary on ProductionTriggerDocument {
  id
  tenantId
  productionTriggerId
  name
  source
  unit
  offset
  expireBy
  status
  createdBy
  createdAt
  updatedBy
  updatedAt
}
    `, {"fragmentName":"ProductionTriggerSummary"});
export const ProductionTriggerDetailsFragmentDoc = new TypedDocumentString(`
    fragment ProductionTriggerDetails on ProductionTriggerStateData {
  tenantId
  productionTriggerId
  name
  source
  unit
  offset
  expireBy
  status
  createdBy
  createdAt
  updatedBy
  updatedAt
}
    `, {"fragmentName":"ProductionTriggerDetails"});
export const GetProductionTriggersDocument = new TypedDocumentString(`
    query GetProductionTriggers($where: ProductionTriggerDocumentFilterInput, $order: [ProductionTriggerDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  productionTriggers(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    totalCount
    nodes {
      ...ProductionTriggerSummary
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment ProductionTriggerSummary on ProductionTriggerDocument {
  id
  tenantId
  productionTriggerId
  name
  source
  unit
  offset
  expireBy
  status
  createdBy
  createdAt
  updatedBy
  updatedAt
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetProductionTriggers: build.query<GetProductionTriggersQuery, GetProductionTriggersQueryVariables | void>({
      query: (variables) => ({ document: GetProductionTriggersDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetProductionTriggersQuery, useLazyGetProductionTriggersQuery } = injectedRtkApi;
